frappe.provide("jhaudio.checkout");

const currencyFmt = new Intl.NumberFormat("en-US");

/**
 * Generic address form component for use in the cart checkout process.
 * @class AddressForm
 * @namespace jhaudio.checkout
 */
jhaudio.checkout.AddressForm = class {
  constructor($container, doc) {
    this.$container = $container;
    this.doc = doc;
    this.fields = [
      'address_title',
      'address_line1',
      'address_line2',
      'address_contact',
      'email_id',
      'is_residential',
      'city',
      'state',
      'country',
      'address_type',
      'pincode',
      'phone',
    ];

    this.mandatory_fields = {
      'address_title': 'Address Label',
      'phone': 'Phone',
      'email_id': 'Contact Email',
      'address_line1': 'Address 1',
      'city': 'City',
      'pincode': 'Zip Code',
      'country': 'Country'
    };

    this.init();
  }

  /**
   * Initializes component and binds.
   */
  async init() {
    const me = this;
    this.$saveBtn = this.$container.find('.save');
    this.$cancelBtn = this.$container.find('.cancel');

    this.$saveBtn.click(this.handleSaveClick.bind(this));
    this.$cancelBtn.click(this.handleCancelClick.bind(this));

    this.$container.find(".field.required input").blur(function () {
      this.handleInputChange($(this));
    })

    this.$container.find(".field.required select").change(function () {
      this.handleSelectChange($(this));
    })

    const r = await frappe.call({ method: "frappe.client.get_list", args: { doctype: "Country", limit_page_length: 999 } });
    this.countries = r.message.map((country) => ({ "label": country.name, "value": country.name }));

    this.$countryField = this.$container.find("select[data-type=country]");
    for (let country of this.countries) {
      const $option = $(`<option value="${country.value}">${country.label}</option>`);
      this.$countryField.append($option);
    }
  }

  /**
   * Binds an event to the component container.
   * @param {*} event
   * @param {*} callback
   */
  on(event, callback) {
    this.$container.on(event, callback);
  }

  /**
   * Sets focus on a field by name
   * @param {*} fieldName
   */
  focus(fieldName) {
    this.$container.find(`[name=${fieldName}]`).focus();
    $('body').scrollTop(0);
  }

  /**
   * Gathers address fields and returns an object. See this.fields for a list of them.
   */
  getAddressFields() {
    const address = this.fields.reduce((obj, field) => {
      const $field = this.$container.find(`[name=${field}]`);
      if ($field && $field.length > 0) {
        Reflect.set(obj, field, $field.val());
      }
      return obj;
    }, {})

    if (this.address.name) {
      address.name = this.address.name
    }

    return address;
  }

  /**
   * Sets all address fields from a provided object.
   * See this.fields for valid fields names
   * @param {*} address
   */
  setFields(address) {
    this.address = address;

    for (let field of this.fields) {
      const value = Reflect.get(address, field) || '';
      const $field = this.$container.find(`[name=${field}]`);
      $field.val(value);
    }
  }

  /**
   * Handles the save click event
   */
  handleSaveClick() {
    this.$container.trigger('save');
    $('html, body').animate({ scrollTop: 0 }, "slow");
  }

  /**
   * Handles the cancel click event
   */
  handleCancelClick() {
    this.$container.trigger('cancel');
    $('html, body').animate({ scrollTop: 0 }, "slow");
  }

  /**
   * Handles input change events.
   * Meant to be overwritten by subclass.
   * @param {*} $input
   */
  handleInputChange($input) { }

  /**
   * Handles select change events.
   * Meant to be overwritten by subclass.
   * @param {*} $input
   */
  handleSelectChange($select) { }
}

/**
 * Generic class address component for shipping and billing common behaviors.
 * @class CartAddressWidgetBase
 * @namespace jhaudio.checkout
 */
jhaudio.checkout.CartAddressWidgetBase = class {
  constructor($target, $container, doc) {
    this.$target = $target;
    this.$container = $container;
    this.$editBtn = $container.find('.edit-btn');
    this.doc = doc;
    this.busy = false;
    this.$filteraddresses = $();
  }

  /**
   * Initializes base component and binds.
   */
  async init() {
    const me = this;
    this.initializing = true;
    this.$addressList = this.$target.find('.address-list');
    this.$addressForm = this.$target.find('.address-form');

    this.addressForm = new jhaudio.checkout.AddressForm(this.$addressForm, this.doc);
    this.addressForm.on('save', this.handleAddressSave.bind(this));
    this.addressForm.on('cancel', this.handleAddressCancel.bind(this));

    // handle address selection
    this.$target.find(".address-card").not(".add-new-address").each(function () {
      $(this).click(function () {
        me.handleCardClick($(this));
      });
    });

    // handle address edit
    this.$target.find(".edit-icon").each(function (e) {
      $(this).click(function (e) {
        e.stopPropagation();
        e.preventDefault();
        me.handleCardEdit($(this.parentNode.parentElement));
      });
    });

    // handle new address button
    this.$target.find(".add-new-address").click(function () {
      me.handleNewAddressButtonClick();
    });

    const $activeAddress = this.$target.find('.address-item[data-active]');
    if ($activeAddress && $activeAddress.length > 0) {
      await this.handleCardClick($activeAddress.find('.address-card'));
    }

    me.setupValidations();
    this.$filteraddresses = this.$target.find(`.address-item:not(.light)`);
    this.address_per_page = 3;
    this.paginate_init();
    this.paginate_update();
    $('#billing_search').on("keyup", function () {
      let filter_text = $(this).val().toLowerCase();
      me.filter_addresses(filter_text);
    });
    $('#shipping_search').on("keyup", function () {
      let filter_keyword = $(this).val().toLowerCase();
      me.filter_addresses(filter_keyword);
    });
    this.initializing = false;
  }

  /**
   * Binds events to the component container
   * @param {*} event
   * @param {*} callback
   */
  on(event, callback) {
    this.$target.on(event, callback);
  }

  /**
   * Handles address card click event for both edit and selection
   * depending on the card's class containing the .edit class
   * @param {*} $card
   */
  async handleCardClick($card) {
    const address_name = $card.attr("data-name");
    this.$target.find('.address-item[data-active]').removeAttr('data-active');
    $card.closest('.address-item').attr('data-active', '');
    await this.onAddressSelected(address_name, $card.attr('data-is-po-box'));
    await this.validate();
  }

  /**
   * Handles new address button click
   */
  async handleCardEdit($card) {
    const address_name = $card.attr("data-name");
    if (address_name) {
      const r = await frappe.call({
        method: "frappe.client.get",
        args: {
          doctype: "Address",
          name: address_name,
        },
        freeze: true
      });

      this.showAddressForm(r.message);
    }
  }

  /**
   * Handles new address button click
   */
  async handleNewAddressButtonClick() {
    $('html, body').animate({ scrollTop: 0 }, "slow", "linear");
    await this.showAddressForm();
    await this.onNewAddressButtonClick();
  }

  /**
   * Appends a pagination div to address list
   * Makes the first page and first page number active
   */
  paginate_init() {
    const me = this;
    this.$target.find('.address-list').append("<div class='address_pagination'></div>");
    this.$target.find('.address_pagination').on('click', '.page_number', function () {
      $(this).parent().children().removeClass('active');
      $(this).addClass('active');
      me.paginate_update_addresses();
    });
  }

  /**
   * Changes the page on click of any page number in the pagination list
   */
  paginate_update_addresses() {
    let $current_page = this.$target.find('.address_pagination .page_number.active')
    let page_index = $current_page.index();
    let start = page_index * this.address_per_page;
    this.$target.find(`.address-item:not(.light)`).removeClass('active');
    for (let j = 0; j < this.address_per_page; j++) {
      this.$filteraddresses.eq(start + j).addClass('active');
    }
  }

  /**
   * Updates the pagination on filter or on page change
   */
  paginate_update() {
    let addressitem_count = this.$filteraddresses.length;
    let number_of_pages = Math.ceil(addressitem_count / this.address_per_page);
    this.$target.find('.address_pagination').empty()
    for (let i = 1; i <= number_of_pages; i++) {
      this.$target.find('.address_pagination').append("<div class='page_number'>" + i + "</div>");
    }
    this.$target.find('.address_pagination .page_number:first').addClass('active')
    this.paginate_update_addresses();
  }

  /**
   * Filters the addresses based on the text entered in the search text box
   * filter value is the value in textbox
   * @param filter
   */
  filter_addresses(filter) {
    let $addresses = this.$target.find(`.address-item:not(.light)`);
    this.$filteraddresses = $addresses.filter(function (index) {
      return $addresses.children().eq(index).text().toLowerCase().indexOf(filter) > -1;
    });
    this.paginate_update();
  }


  /**
   * Handles displaying of address form and field reset when switching from address list.
   * @param {*} address
   */
  async showAddressForm(address = {}) {
    if (address) {
      this.addressForm.setFields(address);
    }

    // move page back to top
    $('html, body').animate({ scrollTop: 0 }, "fast", "linear");

    // track list view width to apply to form
    const width = this.$addressList.width();
    this.$addressList.animate({ width: 0 }, 'fast', "linear")

    // swap form with to address's width
    await this.$addressForm.show().width(0).animate({ width: width }, 'fast').promise();

    // finally hide list
    this.$addressList.hide();
    this.addressForm.focus('title');
  }

  /**
   * Handles displaying address list when switching from address form.
   */
  async showAddressList() {
    // move page back to top
    $('html, body').animate({ scrollTop: 0 }, "fast", "linear");

    // track list view width to apply to form
    const width = this.$addressForm.width();
    this.$addressForm.animate({ width: 0 }, 'fast', "linear")

    // swap form with to address's width
    await this.$addressList.show().width(0).animate({ width: width }, 'fast').promise();

    // finally hide list
    this.$addressForm.hide();
  }

  /**
   * Handles address save button click
   */
  async handleAddressSave() {
    const address = this.addressForm.getAddressFields();
    this.validateValues(address);

    if (this.busy && !this.validationFailed) {
      return;
    }

    this.busy = true;
    await this.onAddressSave(address);
    this.busy = false;
    this.validate();
  }

  /**
   * Handles address cancel button click
   */
  async handleAddressCancel() {
    if (this.busy) {
      return;
    }
    this.busy = true;
    await this.showAddressList();
    await this.onAddressCancel();
    this.busy = false;
  }

  /**
   * Checks address component state validation.
   */
  async validate() {
    await this.onValidate();
  }

  /**
   * Sets internal state as updating while validating component
   * @param {*} updating
   */
  async update(updating) {
    this.updating = updating;
    if (this.updating) {
      this.$container.addClass('updating');
    } else {
      this.$container.removeClass('updating');
    }
    await this.onUpdate(updating);
    await this.validate();
  }

  async onUpdate(updating) { }

  /**
   * When implemented lets subclass handle address selection event.
   * @param {*} address_name The address name identifier
   * @param {*} is_po_box wether or not this address is a po box.
   */
  async onAddressSelected(address_name, is_po_box) { throw new Error("Not Implemented"); }

  /**
   * When implemented lets subclass handle new address button click event.
   */
  async onNewAddressButtonClick() { }

  /**
   * When implemented lets subclass handle cancel address button click event.
   */
  async onAddressCancel() { }

  /**
   * When implemented lets subclass handle save button click event.
   * @param {*} address
   */
  async onAddressSave(address) {
    this.validateValues(address);
  }

  /**
   * When implemented lets subclass handle validation events.
   */
  async onValidate() { }

  validateValues(address) {
    this.validateMandatory(address);
    this.validateEmail(address.email_id);
    this.validatePhone(address.phone);
  }

  setupValidations() {
    let me = this;

    $('input[data-validation="email_id"]')
      .blur(function (event) {
        me.validateEmail(event.target.value);
      });

    $('input[data-validation="phone"]')
      .blur(function (event) {
        me.validatePhone(event.target.value);
      })
      .keypress(function (event) {
        return !((event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123));
      });
  }

  validateMandatory(address) {
    let empty_fields = []

    for (let i in this.addressForm.mandatory_fields) {
      if (is_null(address[i])) {
        empty_fields.push(this.addressForm.mandatory_fields[i]);
      }
    }

    if (empty_fields.length > 0) {
      this.validationFailed = true;
      frappe.throw(__("{0} are mandatory.", [empty_fields.join(", ")]));
    }

    this.validationFailed = false;
  }

  validateEmail(email) {
    if (!validate_email(email)) {
      this.validationFailed = true;
      frappe.throw(__("Please set a valid Email Id."));
    }
    this.validationFailed = false;
  }

  validatePhone(phone) {
    if (phone.length < 5 || phone.length > 20) {
      this.validationFailed = true;
      frappe.throw(__("Please set a valid Phone Number"));
    }
    this.validationFailed = false;
  }
}

